import Swiper, {
	Pagination,
	Autoplay,
	EffectFade,
	Navigation,
	Grid,
} from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "swiper/css/grid";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * Vacancies Filter - HOME
 *
 * Filters by class name as data is fetched from external API.
 * Checks value of filter against class name, if matches display block else display none.
 */
const selectFilter = document.getElementById("vacancies-departments");
const vacanciesSlides = document.querySelectorAll(
	".vacancies-slider__content .swiper-slide"
);
const headerText = document.querySelector(".vacancies-slider__content-text h3");

if (selectFilter) {
	selectFilter.addEventListener("change", function () {
		let value = this.value;
		headerText.innerHTML = value;

		vacanciesSlides.forEach((slide) => {
			if (slide.classList.contains(value)) {
				slide.classList.remove("hide");
				slide.classList.add("show");
			} else if (!slide.classList.contains(value)) {
				slide.classList.remove("show");
				slide.classList.add("hide");
			}
		});
	});
}

/* Hero Slider */

const heroSlider = new Swiper("#heroSlider", {
	modules: [Pagination, Autoplay, EffectFade],
	direction: "horizontal",
	fadeEffect: { crossFade: true },
	autoHeight: true,
	loop: true,
	speed: 800,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
	},
	spaceBetween: 100,
	slidersPerView: 1,
	effect: "fade",
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});

/* Vacancies Slider - Data via API */

const vacanciesSlider = new Swiper("#vacanciesSlider", {
	modules: [Navigation, Grid],
	direction: "horizontal",
	slidersPerView: 1,
	loop: false,

	breakpoints: {
		750: {
			slidersPerView: 2,
		},
		1024: {
			slidesPerView: 3,
			grid: {
				rows: 2,
				fill: "row",
			},
			spaceBetween: 20,
		},
	},

	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

if (window.innerWidth >= 1024) {
	/**
	 * CANDIDATE CARDS HEADER ANIMATION
	 */

	if ($(".front-page__candidates-header").length) {
		var candidateHeader = gsap.timeline();
		candidateHeader
			.fromTo(
				".front-page__candidates-header h2",
				{ y: 30, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 1 }
			)
			.fromTo(
				".front-page__candidates-header p",
				{ y: 30, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 0.5 },
				"<=0.3"
			);

		ScrollTrigger.create({
			start: "top 50%",
			end: "bottom 50%",
			trigger: ".front-page__candidates",
			animation: candidateHeader,
			toggleActions: "play complete none none",
			once: false,
			markers: false,
		});
	}

	/**
	 * CANDIDATE CARDS ANIMATION
	 */

	var candidateCard = gsap.timeline();
	candidateCard.fromTo(
		".front-page__candidates-list .item",
		{ y: 30, autoAlpha: 0 },
		{ y: 0, autoAlpha: 1, duration: 1, stagger: 0.3, ease: "ease" }
	);
	ScrollTrigger.create({
		start: "top 50%",
		end: "bottom 50%",
		trigger: ".front-page__candidates",
		animation: candidateCard,
		toggleActions: "play complete none none",
		once: false,
		markers: false,
	});

	/**
	 * WHO WE ARE TEXT ANIMATION
	 */

	if ($("#who-small-title").length) {
		var fpWhoAnim = gsap.timeline();
		fpWhoAnim
			.fromTo(
				"#who-small-title",
				{ y: 30, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 1 }
			)
			.fromTo(
				"#who-title",
				{ y: 30, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 0.5 },
				"<=0.3"
			)
			.fromTo(
				"#who-text",
				{ y: 30, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 0.5 },
				"<=0.2"
			)
			.fromTo(
				"#who-link",
				{ y: 30, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 0.5 },
				"<=0.1"
			);

		ScrollTrigger.create({
			start: "top 50%",
			end: "bottom 50%",
			trigger: ".front-page__who",
			animation: fpWhoAnim,
			toggleActions: "play complete none none",
			once: false,
			markers: false,
		});
	}

	/**
	 * WHO WE ARE TEXT ANIMATION
	 */

	var fpCards = gsap.timeline();
	fpCards.fromTo(
		".front-page__cards-card",
		{ y: 30, autoAlpha: 0 },
		{ y: 0, autoAlpha: 1, duration: 1, stagger: 0.5, ease: "ease" }
	);
	ScrollTrigger.create({
		start: "top 50%",
		end: "bottom 50%",
		trigger: ".front-page__cards",
		animation: fpCards,
		toggleActions: "play complete none none",
		once: false,
		markers: false,
	});
}
